import AbstractRuleTemplateModel from "./AbstractRuleTemplateModel.js";

/**
 * RuleTemplateModel to use when a rule is defined where we clicked
 */
export default class OwnRuleTemplateModel extends AbstractRuleTemplateModel {
	isOwnRule() {
		return true;
	}

	ruleTemplateWidgetContentRenderer(ruleTemplateWidget) {
		return (html) => ruleTemplateWidget.renderOwnRuleTemplateOn(html);
	}

	ruleTemplateDescriptionWidgetRenderer(ruleTemplateWidget) {
		return (html) =>
			ruleTemplateWidget.renderRuleTemplateDescriptionOn(html);
	}

	_makeSaveActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeUpdateRuleTemplateAction(
			this._ruleTemplate,
		);
	}

	_makeDeleteActionOn(ruleTemplatesWidget) {
		return ruleTemplatesWidget.makeRemoveRuleTemplateAction(
			this._ruleTemplate,
		);
	}
}
